import { FormControl, FormErrorMessage, FormHelperText, Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { Select } from 'chakra-react-select';
import { chakraStyles } from '../common/select/styles';
import FormRow from '@/features/user/FormRow';

const LABEL_COLUMNS = '110px auto';

const JobFeedFormFields = ({
  initialRef,
  name,
  onNameChange,
  nameError,
  url,
  onUrlChange,
  urlError,
  modalities,
  onModalitiesChange,
  modalityOptions,
}) => {
  return (
    <>
      <FormControl isInvalid={nameError} aria-label="name-control">
        <FormRow id="name" label="Name" templateColumns={LABEL_COLUMNS} gap={0} width="100%">
          <Input ref={initialRef} id="name" focusBorderColor="brand.700" value={name} onChange={(e) => onNameChange(e.target.value)} />
        </FormRow>
        <FormErrorMessage ml="110px">Name is required.</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={urlError} aria-label="url-control">
        <FormRow id="url" label="URL" templateColumns={LABEL_COLUMNS} gap={0} width="100%">
          <Input id="url" focusBorderColor="brand.700" value={url} onChange={(e) => onUrlChange(e.target.value)} placeholder="https://example.com/webhook" />
        </FormRow>
        <FormErrorMessage ml="110px">Enter a valid https:// URL.</FormErrorMessage>
      </FormControl>
      <FormControl aria-label="modalities-control">
        <FormRow id="modalities" label="Modalities" templateColumns={LABEL_COLUMNS} gap={0} width="100%">
          <Select
            id="modalities"
            aria-label="modalities"
            chakraStyles={chakraStyles}
            focusBorderColor="brand.700"
            options={modalityOptions}
            value={modalities}
            onChange={(opts) => onModalitiesChange(opts || [])}
            isMulti
            isClearable
            isSearchable
            colorScheme="blue"
            placeholder="All modalities"
          />
        </FormRow>
        <FormHelperText ml="110px">Leave empty to receive jobs for all modalities.</FormHelperText>
      </FormControl>
    </>
  );
};

JobFeedFormFields.propTypes = {
  initialRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  name: PropTypes.string,
  onNameChange: PropTypes.func,
  nameError: PropTypes.bool,
  url: PropTypes.string,
  onUrlChange: PropTypes.func,
  urlError: PropTypes.bool,
  modalities: PropTypes.array,
  onModalitiesChange: PropTypes.func,
  modalityOptions: PropTypes.array,
};

export default JobFeedFormFields;
